import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/forProfessionals_es.json'
import en from '../locales/forProfessionals_en.json'

function ForProfessionals() {
    return <ContentPage es={es} en={en} />
}

export default ForProfessionals
